import Lottie from "lottie-light-react";
import React, { useEffect, useRef } from "react";
import { useNationalDogSurveyContext } from "../../NationalDogSurvey/NationalDogSurvey.context";
import { PAYOFF_ANIMATIONS } from "../../NationalDogSurvey/fixtures";
import * as styles from "./NDSScreenTransition.module.scss";

const TRANSITION_TIMEOUT = 6100;
interface NDSScreenTransitionProps {
	screenState: NDS.ScreenState;
}

const animationMap: Record<
	NDS.TransitionTrigger,
	{
		animation: object;
		message: string;
		title: string;
		titleClassName: string;
	}
> = {
	ABOUT_YOUR_DOGS: {
		animation: PAYOFF_ANIMATIONS.ABOUT_YOUR_DOGS,
		message: "You've completed section 1 of 5 of the survey",
		title: "Wag-tastic!",
		titleClassName: styles.lottieTitle,
	},
	CHOOSING_YOUR_DOG: {
		animation: PAYOFF_ANIMATIONS.CHOOSING_YOUR_DOG,
		message: "You've completed section 2 of 5 of the survey",
		title: "Thank you!",
		titleClassName: styles.lottieTitle,
	},
	UNDERSTANDING_YOUR_DOG: {
		animation: PAYOFF_ANIMATIONS.UNDERSTANDING_YOUR_DOG,

		message: "You've completed section 3 of 5 of the survey",
		title: "Good job!",
		titleClassName: styles.uydAnimationTitle,
	},
	RELATIONSHIP_WITH_YOUR_DOG: {
		animation: PAYOFF_ANIMATIONS.RELATIONSHIP_WITH_YOUR_DOG,
		message: "You've completed section 4 of 5 of the survey",
		title: "Great work!",
		titleClassName: styles.lottieTitle,
	},
	ABOUT_YOU: {
		animation: PAYOFF_ANIMATIONS.ABOUT_YOU,

		message: "You've completed section 5 of 5 of the survey",
		title: "Treat time!",
		titleClassName: styles.lottieTitle,
	},

	THOUGHTS_ON_DOGS: {
		animation: PAYOFF_ANIMATIONS.THOUGHTS_ON_DOGS,

		message: "You've completed section 1 of 2 of the survey",
		title: "Fantastic!",
		titleClassName: styles.lottieTitle,
	},
	ABOUT_YOU_NON_DOG_OWNER: {
		animation: PAYOFF_ANIMATIONS.ABOUT_YOU,
		message: "You've completed section 2 of 2 of the survey",
		title: "Treat time!",
		titleClassName: styles.lottieTitle,
	},
};
export const NDSScreenTransition: React.FC<NDSScreenTransitionProps> = ({
	screenState,
}) => {
	const { transition, surveyState, setSurveyState } =
		useNationalDogSurveyContext();

	const setPlayedTransitionsTimeout = useRef<NodeJS.Timeout | null>(null);
	useEffect(() => {
		if (transition && setSurveyState) {
			setPlayedTransitionsTimeout.current = setTimeout(() => {
				setSurveyState((prevSurveyState) => {
					// Only add the transition if it's not already in the array
					const updatedTransitions = prevSurveyState.playedTransitions.includes(
						transition,
					)
						? prevSurveyState.playedTransitions
						: [...prevSurveyState.playedTransitions, transition];

					return {
						...prevSurveyState,
						playedTransitions: updatedTransitions,
					};
				});
			}, TRANSITION_TIMEOUT);
		}
	}, [transition, setSurveyState]);

	const transitionData = animationMap[transition];
	if (surveyState.playedTransitions?.includes(transition)) {
		return null;
	}

	if (transitionData) {
		return (
			<div className={styles.screenTransitionContainer}>
				<div
					key={screenState.screen}
					className={styles.screenTransitionwithLottie}
					aria-hidden
				>
					<Lottie
						className={styles.lottieAnimation}
						animationData={transitionData.animation}
						loop={false}
						aria-hidden
					>
						<h2 className={transitionData.titleClassName}>
							{transitionData.title}
						</h2>
					</Lottie>
					<p className={styles.lottieText}>{transitionData.message}</p>
				</div>
			</div>
		);
	}
	return (
		<div
			key={screenState.screen}
			className={styles.screenTransition}
			aria-hidden
		/>
	);
};
